<!----------------------------------------------------------Add/Edit New Firearm --------------------------------------------------------->
<div class="modal-content">
  <!--Header-->
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
  >
    <div class="modal-title">
      <h4 class="mb-0">Edit Firearm</h4>
    </div>
    <button
      type="button"
      class="close-btn"
      style="margin-left: auto"
      (click)="closeModalClick()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body pb-4 mt-3">
    <!--body-->
    <form [formGroup]="edit_firearm_form" (ngSubmit)="editFirearmClick()">
      <div class="d-flex flex-column gap-3">
        <!-- Firearm UPC -->
        <div class="row align-items-center position-relative">
          <label
            for="firearm_upc"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            Firearm UPC:
          </label>
          <div class="col-sm-8 flex-grow-1 position-relative">
            <input
              type="text"
              class="form-control modern-input w-100"
              formControlName="firearm_upc"
              name="firearm_upc"
              id="firearm_upc"
              style="padding-right: 35px"
            />
            <i
              class="fa-solid fa-barcode position-absolute"
              style="
                right: 25px;
                top: 50%;
                transform: translateY(-50%);
                color: #6c757d;
              "
            ></i>
          </div>
        </div>

        <!-- Firearm Type -->
        <div class="row align-items-center">
          <label
            for="firearm_type"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            <span class="text-danger">* </span>Firearm Type:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <ng-select
              [items]="firearm_types"
              [multiple]="false"
              [closeOnSelect]="true"
              class="form-control modern-input text-uppercase w-100 p-0 border-0 bg-transparent"
              formControlName="firearm_type"
              name="firearm_type"
              id="firearm_type"
            ></ng-select>
          </div>
        </div>

        <!-- Serial Number -->
        <div class="row align-items-center position-relative">
          <label
            for="serial_number"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            <span class="text-danger">* </span> Serial Number:
          </label>
          <div class="col-sm-8 flex-grow-1 position-relative">
            <input
              #serial_number
              type="text"
              class="form-control modern-input text-uppercase w-100 blackout"
              formControlName="serial_number"
              name="serial_number"
              id="serial_number"
              [style.background-color]="serial_editing_blackout"
              style="padding-right: 35px; color: #ffffff"
              (blur)="compareSerialInputs()"
            />
            @if (
              edit_firearm_form.value.serial_number ===
                edit_firearm_form.value.serial_number2 &&
              edit_firearm_form.value.serial_number &&
              edit_firearm_form.value.serial_number2
            ) {
              <i
                class="fa-solid fa-circle-check position-absolute"
                style="
                  color: #28a745;
                  right: 25px;
                  top: 50%;
                  transform: translateY(-50%);
                "
              ></i>
            }
            @if (
              edit_firearm_form.value.serial_number !==
                edit_firearm_form.value.serial_number2 &&
              edit_firearm_form.value.serial_number &&
              edit_firearm_form.value.serial_number2
            ) {
              <i
                class="fa-solid fa-circle-xmark position-absolute"
                style="
                  color: #dc3545;
                  right: 25px;
                  top: 50%;
                  transform: translateY(-50%);
                "
              ></i>
            }
          </div>
        </div>

        <!-- Serial2 Number -->
        <div class="row align-items-center position-relative">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="serial_number2"
          >
            <span class="text-danger">* </span> Serial Number:
          </label>
          <div class="col-sm-8 flex-grow-1 position-relative">
            <input
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="serial_number2"
              name="serial_number2"
              id="serial_number2"
              style="padding-right: 35px"
              (focus)="serialEdit()"
              (blur)="compareSerialInputs()"
            />
            @if (
              edit_firearm_form.value.serial_number ===
                edit_firearm_form.value.serial_number2 &&
              edit_firearm_form.value.serial_number &&
              edit_firearm_form.value.serial_number2
            ) {
              <i
                class="fa-solid fa-circle-check position-absolute"
                style="
                  color: #28a745;
                  right: 25px;
                  top: 50%;
                  transform: translateY(-50%);
                "
              ></i>
            }
            @if (
              edit_firearm_form.value.serial_number !==
                edit_firearm_form.value.serial_number2 &&
              edit_firearm_form.value.serial_number &&
              edit_firearm_form.value.serial_number2
            ) {
              <i
                class="fa-solid fa-circle-xmark position-absolute"
                style="
                  color: #dc3545;
                  right: 25px;
                  top: 50%;
                  transform: translateY(-50%);
                "
              ></i>
            }
          </div>
        </div>

        <!-- Manufacture -->
        <div class="row align-items-center">
          <label
            for="manufacture"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            <span class="text-danger">* </span>Manufacture:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input w-100"
              formControlName="manufacture"
              name="manufacture"
              id="manufacture"
            />
          </div>
        </div>

        <!-- Importer -->
        <div class="row align-items-center">
          <label
            for="importer"
            class="col-sm-4 col-form-label form-label text-end mb-0"
            >Importer:</label
          >
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input w-100"
              formControlName="importer"
              name="importer"
              id="importer"
            />
          </div>
        </div>

        <!-- Model -->
        <div class="row align-items-center">
          <label
            for="model"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            <span class="text-danger">* </span>Model:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input w-100"
              formControlName="model"
              name="model"
              id="model"
            />
          </div>
        </div>

        <!-- Additional Markings -->
        <div class="row align-items-center">
          <label
            for="additional_markings"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            Additional Markings:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input w-100"
              formControlName="additional_markings"
              name="additional_markings"
              id="additional_markings"
            />
          </div>
        </div>

        <!-- Caliber / Gauge -->
        <div class="row align-items-center">
          <label
            for="caliber_gauge"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            <span class="text-danger">* </span>Caliber / Gauge:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input w-100"
              formControlName="caliber_gauge"
              name="caliber_gauge"
              id="caliber_gauge"
            />
          </div>
        </div>

        <!-- Edit Notes -->
        <div class="row align-items-start">
          <label
            for="edit_note"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            <span class="text-danger">* </span>Edit Note:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <textarea
              class="form-control modern-input w-100"
              formControlName="edit_note"
              id="edit_note"
              name="edit_note"
              style="min-height: 100px; resize: vertical"
              rows="4"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="d-flex justify-content-between mt-3 px-3">
        <!--Cancel-->
        <button
          type="button"
          class="btn modern-btn secondary-btn px-4"
          (click)="closeModalClick()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn modern-btn primary-btn px-4"
          [disabled]="edit_firearm_form.invalid || !edit_firearm_form.dirty"
        >
          Edit Firearm
        </button>
      </div>
    </form>

    <div class="mt-4 ms-2">
      <span class="text-danger">*</span>
      <span class="text-light" style="font-size: 0.9rem"
        >denotes required fields</span
      >
    </div>
  </div>
</div>

